module.exports = __webpack_public_path__ + "static/media/alerts.4b067424.svg";